<section>
    <div class="heading">
        <h4>Leaderboard</h4>
        <span>*Points, badges, and tiers require at least 24 hours to be updated.</span>
        <span *appUserRoles="[UserRoleUid.PARTNER, UserRoleUid.EMPLOYEE]" class="non-customer">
            **Rewards are currently available to Genesys customers only. Employees and partners are not eligible for
            point redemption at this time.
        </span>
    </div>
    <div class="tab-group-container">
        <mat-tab-group animationDuration="250ms" (selectedIndexChange)="onTabChange($event)">
            <mat-tab label="My Stats">
                <ng-container *ngTemplateOutlet="myStatsContent"></ng-container>
            </mat-tab>
            <mat-tab label="Daily">
                <ng-container *ngTemplateOutlet="userListContent"></ng-container>
            </mat-tab>
            <mat-tab label="All Time">
                <ng-container *ngTemplateOutlet="userListContent"></ng-container>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>

<ng-template #loading>
    <li>
        <div class="loading-user-wrapper">
            <app-loading-skeleton [rows]="1" [rowHeight]="39" [circle]="true"></app-loading-skeleton>
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        </div>
        <div class="loading-rank-wrapper">
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        </div>
        <div class="loading-points-wrapper">
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        </div>
    </li>
</ng-template>

<ng-template #userListContent>
    @if (tab$ | async; as tab) {
        <div class="search-container">
            <button
                class="search-btn"
                (click)="performSearch()"
                matTooltip="Search"
                [matTooltipShowDelay]="1000"
                [ngClass]="{ disabled: isSearching }"
                [disabled]="isSearching">
                <mat-icon [svgIcon]="'search'" aria-hidden></mat-icon>
            </button>
            <input
                type="text"
                name="orchestrator"
                [(ngModel)]="orchestrator"
                placeholder="Find an Orchestrator"
                (keydown.enter)="performSearch()"
                class="search-bar"
                [ngClass]="{ disabled: isSearching }"
                [disabled]="isSearching" />
            <button
                class="close"
                *ngIf="orchestrator"
                (click)="clearSearch()"
                matTooltip="Clear search"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000"
                [ngClass]="{ disabled: isSearching }"
                [disabled]="isSearching">
                <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
            </button>
        </div>
        <ul>
            <li class="labels">
                <div class="label-user-wrapper">
                    <span>ORCHESTRATOR</span>
                </div>
                <div class="label-rank-wrapper">
                    <span>RANK</span>
                </div>
                <div class="label-points-wrapper">
                    <span>POINTS</span>
                </div>
            </li>
            @if (users$ | async; as users) {
                @for (user of users | slice: 0 : length; track $index; let i = $index) {
                    <li>
                        <div class="user-wrapper">
                            <div class="user-avatar">
                                <span class="user-initials">{{ user?.name | getInitials }}</span>
                            </div>
                            <span class="user-name">{{ formatUserName(user?.name) }}</span>
                        </div>
                        <div class="rank-wrapper">
                            <span class="rank">{{ user.ranking }}</span>
                        </div>
                        <div class="points-wrapper">
                            <span class="points">
                                {{ user?.type == 'realtime' ? user?.activityTypeScore : user?.engagementScore }}
                            </span>
                        </div>
                    </li>
                } @empty {
                    <li>
                        @if ((tab$ | async) === LeaderboardRange.REALTIME) {
                            <span class="oops">Oops! This user may not have completed any activities recently.</span>
                        } @else {
                            <span>No matches.</span>
                        }
                    </li>
                }
            } @else {
                @for (i of Array(length).fill(0); track $index) {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            }
        </ul>
    } @else {
        @for (i of Array(length).fill(0); track $index) {
            <ng-container *ngTemplateOutlet="loading"></ng-container>
        }
    }
</ng-template>

<ng-template #myStatsContent>
    <div class="stats-container">
        <ng-container *ngIf="user$ | async as user; else noStats">
            <div *ngIf="pfpLink$ | async as pfpLink; else initialsAvatar" class="user-avatar">
                <img [src]="pfpLink" alt="Profile picture" />
            </div>
            <ng-template #initialsAvatar>
                <div
                    class="user-avatar"
                    [style.background-color]="getInitialsColors(user?.name | getInitials).backgroundColor">
                    <p class="user-initials" [style.color]="getInitialsColors(user?.name | getInitials).textColor">{{
                        user?.name | getInitials
                    }}</p>
                </div>
            </ng-template>
            <div class="ranking-container">
                <div class="orchestrators-ranking">
                    <mat-icon [svgIcon]="'wave'" aria-hidden></mat-icon>
                    <p class="typography-special-uppercase-small">ORCHESTRATORS RANKING</p>
                    <h5>#{{ user?.ranking || -1 }}</h5>
                    <p> out of {{ outOfValue || '48,380' }} </p>
                </div>
            </div>
            <div class="points-container">
                <div class="orchestrators-points">
                    <mat-icon [svgIcon]="'subtract'" aria-hidden></mat-icon>
                    <p class="typography-special-uppercase-small">REDEEMABLE POINTS</p>
                    <h5>{{ user?.engagementScoreAvailable || 0 }}</h5>
                </div>
                <div class="orchestrators-points">
                    <mat-icon [svgIcon]="'trophy-ranking'" aria-hidden></mat-icon>
                    <p class="typography-special-uppercase-small"
                        >LIFETIME<br />
                        POINTS</p
                    >
                    <h5>{{ user?.engagementScore || 0 }}</h5>
                </div>
            </div>
            <div class="activity">
                <div class="last-activity">
                    <div class="completed">
                        <mat-icon [svgIcon]="'bullseye'" aria-hidden></mat-icon>
                        <p class="typography-special-uppercase-small">LAST ACTIVITY COMPLETED</p>
                    </div>
                    <div class="date">
                        <p class="caption-c3">
                            {{ lastActivityName$ | async }}<br /><br />
                            {{ formatLastActivityDate(user?.lastActivity) }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noStats>
            <div *appUnauthed class="no-stats">
                <span class="caption-2 margin-bottom-small">Sign in to see your Orchestrator stats.</span>
                <button
                    class="button-primary"
                    (click)="signInWithRedirect($event)"
                    [matTooltip]="'Sign in to see your Orchestrator stats'"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="2000">
                    Sign in
                </button>
                <span class="caption-2 margin-top-large margin-bottom-small">Don't have an account?</span>
                <a
                    class="button-outlined-inverted"
                    [matTooltip]="'Sign up for your free account'"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="2000"
                    [routerLink]="'/' + signUpRoute"
                    >Sign up for your free account
                </a>
            </div>
            <div *appAuthed class="no-stats">
                <span class="caption-2 margin-bottom-small"
                    >Opt into Advocacy on
                    <a
                        mat-menu-item
                        [routerLink]="profileRoutePath"
                        matTooltip="View my profile"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        data-testId="my-profile">
                        Your Profile
                    </a>
                    Preferences to see your Orchestrator stats.</span
                >
            </div>
        </ng-template>
    </div>
</ng-template>
